import { render, staticRenderFns } from "./storage-server.vue?vue&type=template&id=df5ac640&"
import script from "./storage-server.vue?vue&type=script&lang=js&"
export * from "./storage-server.vue?vue&type=script&lang=js&"
import style0 from "./storage-server.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports